import { useCallback, useMemo, useReducer} from 'react'

import useEventCallback from './useEventCallback'










































const reducer = (state, action) => {
  switch (action.type) {
    case 'setDirty':
      if (state[action.name].dirty) return state
      return {
        ...state,
        [action.name]: {
          ...state[action.name],
          dirty: true
        }
      }
    case 'setError':
      if (state[action.name].error === action.error) return state
      return {
        ...state,
        [action.name]: {
          ...state[action.name],
          error: action.error
        }
      }
    case 'setValue':
      if (state[action.name].value === action.value) return state
      return {
        ...state,
        [action.name]: {
          ...state[action.name],
          value: action.value
        }
      }
  }
}

const useForm = (fieldInputDict, deps = []) => {
  const [state, dispatch] = useReducer(
    reducer,
    useMemo(
      () =>
        Object.keys(fieldInputDict).reduce((obj, name) => {
          obj[name] = {
            value: fieldInputDict[name].getDefault(),
            error: undefined,
            dirty: false,
            resetValue: (value = '') => {
              dispatch({type: 'setValue', name, value})
            },
            setError: (error) => {
              dispatch({type: 'setError', name, error})
            }
          }
          return obj
        }, {} ),
      [
        /* eslint-disable-line react-hooks/exhaustive-deps */
      ]
    )
  )

  const normalize = useCallback(
    (name, value) => {
      const normalizeField = fieldInputDict[name].normalize
      const prevValue = state[name].value
      return normalizeField ? normalizeField(value, prevValue) : value
    },
    [...deps, state]
  )

  const validate = useEventCallback((name, value) => {
    const validateField = fieldInputDict[name].validate
    if (!validateField) return {error: undefined, value}
    const res = validateField(value)
    dispatch({type: 'setError', name, error: res.error})
    return res
  })

  

  function _validateField(name) {
    if (!name) {
      return Object.keys(state).reduce((obj, name) => {
        obj[name ] = _validateField(name)
        return obj
      }, {} )
    }
    return validate(name, state[name].value)
  }

  const validateField = useEventCallback(_validateField)

  const setDirty = useEventCallback((name) => {
    if (!name) {
      Object.keys(state).forEach((name) => setDirty(name))
      return
    }
    dispatch({type: 'setDirty', name})
  })

  const setValue = useEventCallback((name, value) => {
    dispatch({type: 'setValue', name, value})
  })
  const onChange = useEventCallback((e) => {
    const {value} = e.target
    const name = e.target.name
    const normalizedValue = normalize(name, value)
    setValue(name, normalizedValue)
    validate(name, normalizedValue)
  })

  return {setDirtyField: setDirty, setValue, onChange, validateField, fields: state}
}

export default useForm
